import type { OHLCVData } from '../sdk'

export interface PriceRange {
  min: number
  max: number
}

export function calculatePriceRange(bars: OHLCVData[]): PriceRange {
  if (!bars || bars.length === 0) {
    return { min: 0, max: 0 }
  }

  let minPrice = Infinity
  let maxPrice = -Infinity

  for (const bar of bars) {
    minPrice = Math.min(minPrice, bar.low)
    maxPrice = Math.max(maxPrice, bar.high)
  }

  return { min: minPrice, max: maxPrice }
}

function randomRange(min: number, max: number): number {
  return Math.random() * (max - min) + min
}

export function generateFakeOHLCBars(realBars: OHLCVData[], priceRange: PriceRange): OHLCVData[] {
  if (!realBars || realBars.length === 0) {
    return []
  }

  const { min, max } = priceRange
  const fakeBars: OHLCVData[] = []

  let currentPrice = randomRange(min + (max - min) * 0.4, min + (max - min) * 0.6)

  for (let i = 0; i < realBars.length; i++) {
    const realBar = realBars[i]

    const movePercent = randomRange(-0.005, 0.005)
    let newPrice = currentPrice * (1 + movePercent)

    newPrice = Math.max(min, Math.min(max, newPrice))

    const open = currentPrice
    const close = newPrice

    const highExtra = randomRange(0, (max - min) * 0.001)
    const lowExtra = randomRange(0, (max - min) * 0.001)

    let high = Math.max(open, close) + highExtra
    let low = Math.min(open, close) - lowExtra

    high = Math.min(max, high)
    low = Math.max(min, low)

    const fakeBar: OHLCVData = {
      timestamp: realBar.timestamp,
      open,
      high,
      low,
      close,
      volume: realBar.volume,
    }

    fakeBars.push(fakeBar)
    currentPrice = close
  }

  return fakeBars
}
